import Tagify from '@yaireo/tagify'

export function initTagify() {
  function getTagAddCsrfToken(addUrl) {
    const fallbackToken = ''

    if (!addUrl) {
      return fallbackToken
    }

    const pathname = new URL(addUrl, window.location.origin).pathname

    if (pathname.endsWith('/faq/tags/add')) {
      return document.querySelector('meta[name="csrf-token-faq-add-tag"]')?.getAttribute('content') || fallbackToken
    }

    if (pathname.endsWith('/infotheek/tags/add')) {
      return (
        document.querySelector('meta[name="csrf-token-infotheek-add-tag"]')?.getAttribute('content') || fallbackToken
      )
    }

    if (pathname.endsWith('/logos/tags/add')) {
      return document.querySelector('meta[name="csrf-token-logo-add-tag"]')?.getAttribute('content') || fallbackToken
    }

    return fallbackToken
  }

  const selectTagElements = document.querySelectorAll('.select-tags')

  selectTagElements.forEach(function (element) {
    if (element.tagName !== 'SELECT') {
      return
    }

    const inputElement = document.createElement('input')
    inputElement.type = 'text'
    inputElement.className = element.className
    inputElement.dataset.searchUrl = element.dataset.searchUrl
    inputElement.dataset.addUrl = element.dataset.addUrl

    if (element.id) inputElement.id = element.id

    const searchUrl = element.dataset.searchUrl
    const addUrl = element.dataset.addUrl

    let selectedTags = []

    // Extract existing selected options and prepare initial value
    const existingOptions = element.querySelectorAll('option[selected]')
    let initialTags = []
    if (existingOptions.length > 0) {
      existingOptions.forEach((option) => {
        const tagData = {
          id: option.value,
          value: option.textContent,
          text: option.textContent,
        }
        selectedTags.push(tagData)
        initialTags.push(tagData)
      })
    }

    element.parentNode.insertBefore(inputElement, element)
    element.style.display = 'none'

    try {
      const tagify = new Tagify(inputElement, {
        placeholder: 'Zoek of voeg tags toe...',
        maxTags: 50,
        dropdown: {
          maxItems: 8,
          enabled: 0,
          closeOnSelect: false,
        },
        whitelist: [],
        enforceWhitelist: false,
        editTags: false,
        tagTextProp: 'text',
      })

      if (initialTags.length > 0) {
        tagify.addTags(initialTags)
      }
      element.tagify = tagify
      element.selectedTags = selectedTags
      inputElement.tagify = tagify
      inputElement.selectedTags = selectedTags

      let controller
      tagify.on('input', function (e) {
        const value = e.detail.value.trim()

        if (!searchUrl || value.length < 1) {
          return
        }
        if (controller) {
          controller.abort()
        }
        controller = new AbortController()
        tagify.loading(true)

        const searchParams = new URLSearchParams({
          q: value,
          page_limit: 8,
        })

        fetch(`${searchUrl}?${searchParams}`, {
          signal: controller.signal,
        })
          .then((response) => response.json())
          .then((data) => {
            const suggestions = data.map((item) => ({
              value: item.text,
              text: item.text,
              id: item.id,
            }))

            tagify.whitelist = suggestions
            tagify.dropdown.show()
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              throw error
            }
          })
          .finally(() => {
            tagify.loading(false)
          })
      })

      function updateSelectedTags(tagData, action) {
        if (tagData === null || tagData === undefined) {
          return
        }

        if (action === 'add' && tagData.id) {
          const existingTag = selectedTags.find((tag) => tag.id === tagData.id)
          if (!existingTag) {
            selectedTags.push({
              id: tagData.id,
              value: tagData.text || tagData.value,
              text: tagData.text || tagData.value,
            })
          }
        } else if (action === 'remove' && tagData.id) {
          selectedTags = selectedTags.filter((tag) => tag.id !== tagData.id)
        }
        element.selectedTags = selectedTags
        inputElement.selectedTags = selectedTags
      }

      tagify.on('add', function (e) {
        const tagData = e.detail.data

        if (tagData._processed) {
          return
        }

        if (addUrl && !tagData.id) {
          tagData._processed = true
          const csrfToken = getTagAddCsrfToken(addUrl)

          tagify.loading(true)

          fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify({
              text: tagData.value,
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Tag creation failed with status ${response.status}`)
              }

              return response.json()
            })
            .then((data) => {
              if (data.id && data.text) {
                tagData.id = data.id
                tagData.text = data.text
                updateSelectedTags(tagData, 'add')
              } else {
                throw new Error('Invalid response data')
              }
            })
            .catch((error) => {
              console.error('Error creating tag:', error) //eslint-disable-line no-console
              tagify.removeTag(tagData)
            })
            .finally(() => {
              tagify.loading(false)
            })
        } else if (tagData.id && !tagData._processed) {
          tagData._processed = true
          updateSelectedTags(tagData, 'add')
        }
      })

      tagify.on('remove', function (e) {
        const tagData = e.detail.data
        updateSelectedTags(tagData, 'remove')
      })
    } catch (error) {
      console.error('Error creating Tagify instance:', error) //eslint-disable-line no-console
    }
  })

  document.querySelectorAll('form').forEach((form) => {
    form.addEventListener('submit', function (e) {
      const tagSelects = form.querySelectorAll('select.select-tags')
      tagSelects.forEach((tagsSelect) => {
        if (tagsSelect.selectedTags) {
          tagsSelect.innerHTML = ''

          tagsSelect.selectedTags.forEach((tag) => {
            const option = document.createElement('option')
            option.value = tag.id
            option.textContent = tag.value || tag.text
            option.selected = true
            tagsSelect.appendChild(option)
          })
        }
      })
    })
  })
}
